export enum AuthMethod {
    FB = 'fb',
    GOOGLE = 'google',
    GOOGLE_ONE_TAP = 'google_one_tap',
    EMAIL = 'email',
    /** @deprecated  */
    TW = 'tw',
    WEB_GUEST = 'web',
    GPGS = 'gpgs',
    IOSGC = 'iosgc',
    APPLE_ID = 'apple_id',
    ANDROID_GUEST = 'android_guest',
    IOS_GUEST = 'ios_guest',
    /** @deprecated  */
    STEAM = 'steam',
    /** @deprecated  */
    VK = 'vk',
    /** @deprecated  */
    OD = 'od',
    /** @deprecated  */
    MM = 'mm',
}
